export default __webpack_public_path__ + "static/media/react_native.507c7c57.svg";